export default __webpack_public_path__ + "static/media/GnosisSafe.20ad5c61.png";